import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class HorizontalLayoutVerticalAlign extends BaseOption {
  static userInterfaceComponent = {
    label: "Vertical Align",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          icon: "align-top",
          value: "top",
        },
        {
          icon: "align-middle",
          value: "middle",
        },
        {
          icon: "align-bottom",
          value: "bottom",
        },
      ],
    },
  };

  static defaultValue = "top";

  static convertConfigValueToCompiledValue(configValue) {
    if (typeof configValue === "string") {
      return configValue;
    }
    if (configValue && configValue.value) {
      return configValue.value;
    }
  }
}
